import React, { useEffect, useRef, useState } from 'react';
import {
   Tabs,
   useView,
   useDidUpdateEffect,
   useDidUpdateDeepCompareLayoutEffect,
   ToastList,
} from '@devesharp/react/web';
import dateFNS from 'date-fns';
import { FormHandles } from '@unform/core';
import { useHistory, useParams } from 'react-router-dom';
import {
   DataDashResolve,
   PaymentsGetResolve,
   PaymentsIdezBoletoPdfResolve,
   PaymentsSearchResolve,
   SubscriptionsDeleteResolve,
   SyncZoopResolve,
} from '~/api';

type PaymentDetailResource = {
   provider?: string;
   url?: string;
   payment_type?: string;
   payment_method?: {
      provider?: string;
      barcode?: string;
   };
   [key: string]: any;
};

export function usePaymentsDetailPage(): any {
   const { id } = useParams() as any;
   document.title = 'Detalhes da venda - XPAG Tecnologia';
   const history = useHistory();

   const { starting, errorLoadData, reloadPage, registerResolveParams, registerOnInit, setStatusInfo } = useView({
      resolves: {
         resource: PaymentsGetResolve,
      },
   });

   const [resource, setResource] = useState<PaymentDetailResource | undefined>();
   const formRef = useRef<FormHandles>();

   registerResolveParams('resource', () => id);

   registerOnInit((res: any) => {
      // colocar original_amount = amount pois mostra saldo da conta o inves do valor "original"
      if (res.resource.payment_type == 'commission') {
         res.resource.original_amount = res.resource.amount;
      }
      setResource(res.resource);
   });

   function goBack() {
      history.goBack();
   }

   function onSync() {
      setStatusInfo(() => ({
         loading: true,
      }));
      SyncZoopResolve(id).subscribe(
         () => {
            setStatusInfo(() => ({
               loading: false,
            }));
            ToastList.show({
               message: 'Boleto sincronizado com sucesso!',
               type: 'success',
            });
            reloadPage(false);
         },
         () => {
            setStatusInfo(() => ({
               loading: false,
            }));
         },
      );
   }

   function onOpenBoleto() {
      if (!resource) {
         return;
      }

      const openUrl = (url: string) => {
         window.open(url, '_blank', 'noopener,noreferrer');
      };

      if (resource.url) {
         openUrl(resource.url);
         return;
      }

      const isIdez = resource.provider === 'idez' || resource.payment_method?.provider === 'idez';

      if (!isIdez) {
         return;
      }

      setStatusInfo(() => ({
         loading: true,
      }));

      PaymentsIdezBoletoPdfResolve(id).subscribe(
         (data) => {
            setStatusInfo(() => ({
               loading: false,
            }));

            if (!data?.url) {
               ToastList.show({
                  message: 'Erro ao abrir boleto',
                  type: 'error',
               });
               return;
            }

            setResource((current) => (current ? { ...current, url: data.url } : current));
            openUrl(data.url);
         },
         () => {
            setStatusInfo(() => ({
               loading: false,
            }));
            ToastList.show({
               message: 'Erro ao abrir boleto',
               type: 'error',
            });
         },
      );
   }

   function cancelSubscription(id: any) {
      const confirm = window.confirm(
         `Tem certeza que deseja cancelar essa assinatura? Essa ação não poderá ser desfeita.`,
      );

      if (!confirm) return;

      setStatusInfo(() => ({
         loading: true,
      }));
      SubscriptionsDeleteResolve(id).subscribe(
         () => {
            reloadPage(false);
            setStatusInfo(() => ({
               loading: false,
            }));
            ToastList.show({
               message: 'Assinatura cancelada com sucesso!',
            });
         },
         () => {
            setStatusInfo(() => ({
               loading: false,
            }));
            ToastList.show({
               message: 'Erro ao cancelar assinatura',
               type: 'error',
            });
         },
      );
   }

   // useDidUpdateEffect(() => {
   //    // setPage(currentPage);
   // }, [currentPage]);

   return {
      onSync,
      onOpenBoleto,
      starting,
      errorLoadData,
      resource,
      goBack,
      cancelSubscription,
   };
}
